export const DEFAULT_REVIEW_COUNT = 20;
export const DESCRIPTION_MIN_LENGTH = 40;
export const REVIEW_SECTION_ID = 'reviews';
export const RICH_CONTENT_SECTION_ID = 'rich-content';
